module.exports = __webpack_public_path__ + "static/img/female-bg-en.06560360.png";